module.exports = __webpack_public_path__ + "24e004ab/img/upload-icon.9179ae4e.svg";